import isBase64 from 'is-base64';
import { Base64 } from 'js-base64';
import { GetProperty } from '../../../../utils/index.js';

/**
 * Base64 字符串解码
 * @param {string} base64Str - Base64 字符串
 * @returns {string} 解码后的字符串
 */
export const base64ToStr = (base64Str) => {
  if (isBase64(base64Str)) {
    return Base64.decode(base64Str);
  }
  return base64Str;
};

/**
 * 获取选中矩形的唯一标识
 * @param {Object} params
 * @param {Object} params.data - 数据对象
 * @param {string} params.key - 坐标字段路径
 * @param {string} params.valStr - 值字符串
 * @returns {string} 唯一标识
 */
export const getSelectRectKey = ({ data, key, valStr }) => {
  try {
    if (!data || !valStr) return '';
    if (!key) return valStr;
    const coordStr = GetProperty(data, key);
    return valStr + JSON.stringify(coordStr);
  } catch (err) {
    return '';
  }
};

/**
 * 获取告警列表
 * @param {Object} params - 响应参数
 * @returns {Array} 告警列表
 */
export const getWarnList = (params) => {
  const warnList = [];
  Object.keys(params).forEach(key => {
    if (params[key] && params[key].IsWarn) {
      warnList.push({
        key,
        ...params[key]
      });
    }
  });
  return warnList;
};

/**
 * 复制文本到剪贴板
 * @param {any} content - 要复制的内容
 */
export const copyToClipboard = (content) => {
  const text = typeof content === 'object' ? JSON.stringify(content, null, 2) : String(content);
  navigator.clipboard.writeText(text);
};
